/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { AboutDialogComponent } from './about-dialog.component';
export { AboutDialogModule } from './about-dialog.module';